module.exports = __webpack_public_path__ + "../front/img/368dobbelbøjlestang.deab00bd.svg";